import { render, staticRenderFns } from "./tabFormsPackages.vue?vue&type=template&id=4ab6bdb2&"
import script from "./tabFormsPackages.vue?vue&type=script&lang=js&"
export * from "./tabFormsPackages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports